import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { socialApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { getSetupGuide } from './config/platformSetupGuides';
import { PlatformSetupWizard } from './components/PlatformSetupWizard';
import type { SocialAccountResponse } from '@/types/social';
import { showApiError } from '@/utils/apiError';

export function PlatformSetupWizardPage() {
  const { platformId } = useParams<{ platformId: string }>();
  const guide = platformId ? getSetupGuide(platformId) : undefined;
  const [accounts, setAccounts] = useState<SocialAccountResponse[]>([]);

  const load = () => {
    socialApi.listAccounts().then(setAccounts).catch((err) => showApiError(err, 'Failed to load accounts'));
  };

  useEffect(() => {
    load();
  }, []);

  if (!guide) {
    return <Navigate to="/social/connect?tab=guides" replace />;
  }

  return (
    <div>
      <PageHeader
        title={`${guide.label} setup`}
        description={guide.overview}
        breadcrumbs={[
          { label: 'Social', to: '/social' },
          { label: 'Connection Center', to: '/social/connect' },
          { label: guide.label },
        ]}
      />
      <PlatformSetupWizard guide={guide} accounts={accounts} onRefresh={load} />
    </div>
  );
}
